import React from 'react';
import AtlasButton from './AtlasButton.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';
import Spinner from '../Spinner/Spinner.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// type LoadingSpinnerProps = Pick<
//   AtlasButtonProps,
//   "appearance" | "isSelected" | "spacing"
// >;
function getSpinnerAppearance({
  appearance,
  isDisabled,
  isSelected
}) {
  if (isDisabled) {
    return 'inherit';
  }
  if (isSelected) {
    return 'invert';
  }
  if (appearance === 'primary' || appearance === 'danger') {
    return 'invert';
  }
  return 'inherit';
}
const LoadingSpinner = ({
  spacing = 'default',
  ...rest
}) => {
  const size = spacing === 'default' ? 'medium' : 'small';
  return /*#__PURE__*/React.createElement(Spinner, {
    size: size,
    appearance: getSpinnerAppearance(rest)
  });
};
LoadingSpinner.displayName = "LoadingSpinner";
/**
 * Use as a drop-in replacement for LoadingButton in Atlassian product scenarios
 *
 * Allows you to show spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * Applies a spinner with the correct size and color based on the button spacing and appearance props.
 *
 */
const AtlasLoadingButton = /*#__PURE__*/React.forwardRef(function LoadingButton({
  isLoading = false,
  children,
  ...rest
}, ref) {
  // Button already has React.memo, so just leaning on that
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AtlasButton, _extends({}, rest, {
    ref: ref,
    overlay: isLoading ? /*#__PURE__*/React.createElement(LoadingSpinner, rest) : null
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, "loading"), children));
});
var AtlasLoadingButton$1 = AtlasLoadingButton;

export { AtlasLoadingButton$1 as default };
